import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_ORIGIN = 'https://odiumworld.com';

/**
 * Ставит <link rel="canonical"> на адрес текущей страницы.
 * В public/index.html canonical намеренно НЕТ: статичный тег указывал на главную у всех страниц,
 * и Google считал вики/гайд копиями главной. Query-строка отбрасывается (utm, ?guide=, ?tab=).
 */
const CanonicalUrl: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = SITE_ORIGIN + path;
  }, [pathname]);

  return null;
};

export default CanonicalUrl;
